export default "/images/0185ebe85cf7b9816e285b10868de1c4.avif";